module.exports = __webpack_public_path__ + "static/media/hive.ae0e66fb.csv";